import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { defer, forkJoin, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { EmploymentRecordStockPurchasePlan } from './models/employment-record-stock-purchase-plan.model';
import { EmploymentRecordStockPurchasePlanService } from './services/employment-record-stock-purchase-plan.service';
import { EmploymentRecordStockPurchasePlanDialogComponent } from './components/employment-record-stock-purchase-plan-dialog/employment-record-stock-purchase-plan-dialog.component';

@Component({
  selector: 'app-employment-record-stock-purchase-plan',
  templateUrl: './employment-record-stock-purchase-plan.component.html',
  styleUrls: ['./employment-record-stock-purchase-plan.component.scss']
})
export class EmploymentRecordStockPurchasePlanComponent implements OnInit {
  @Input() employeeId: string;
  @Input() employmentRecordId: string;
  public columns: any[] = [
    { field: "division", subField: "text", title: "Division", type: "navigation"},
    { field: "member", subField: "text", title: "Member" },
    { field: "employeeContributionPercentage", title: "Employee Contribution Percentage" },
    { field: "employerContributionPercentage", subField: "text", title: "Employer Contribution Percentage" },
    { field: "employeeVoluntaryPercentage", title: "Employee Voluntary Percentage" },
    { field: "enrollmentDate", title: "Enrollment Date", type: "date" },
    { field: "comments", title: "Comments" },
  ];
  public bindingType: String = "array";
  public view: Observable<GridDataResult>;
  public gridData: any;
  public gridDataResult: GridDataResult;
  isLoading: boolean;
  pageSize: number = 5;
  skip: number = 0;

  constructor(
    private dialog: MatDialog,
    private overlayService: OverlayService,
    private snackbarService: SnackbarService,
    private employmentRecordStockPurchasePlanService: EmploymentRecordStockPurchasePlanService
  ) {}

  ngOnInit(): void {
    this.view = this.employmentRecordStockPurchasePlanService.getStockPurchasePlans(this.employeeId, this.employmentRecordId);
    this.getStockPurchasePlans();
  }

  getStockPurchasePlans(): void {
    this.isLoading = true;

    this.employmentRecordStockPurchasePlanService.getStockPurchasePlans(this.employeeId, this.employmentRecordId, this.pageSize, this.skip)
    .pipe(
        finalize(()=>{ this.isLoading = false; })
    )
    .subscribe(
      res => {
        this.gridDataResult = {
          data: res.stockPurchasePlans,
          total: res.pagination.TotalCount,
        }
        this.gridData = res.employmentRecords;
      }
    )
  }

  openEmploymentRecordStockPurchasePlanDialog(employmentRecordStockPurchasePlan?: EmploymentRecordStockPurchasePlan) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      employmentRecordId: this.employmentRecordId,
      employeeId: this.employeeId,
      StockPurchasePlanId: employmentRecordStockPurchasePlan ? employmentRecordStockPurchasePlan.id : null
    };

    const dialogRef = this.dialog.open(EmploymentRecordStockPurchasePlanDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data === true) {
          this.getStockPurchasePlans();
        }
      }
    );
  }

  deleteEmploymentRecordStockPurchasePlan(employmentRecordStockPurchasePlanIds: string[]) {
    const observables = employmentRecordStockPurchasePlanIds.map(selectedItem => defer(() => this.employmentRecordStockPurchasePlanService.deleteStockPurchasePlan(this.employeeId, this.employmentRecordId, selectedItem)));

    this.overlayService.show();

    forkJoin(observables)
    .pipe(
      finalize(() => this.overlayService.hide())
    )
    .subscribe(
      (res) => {
        this.getStockPurchasePlans();
        this.snackbarService.openSnackBar('Deleted successfully', 'clear', 'success');
      },
      err => {
        this.snackbarService.openSnackBar(err, 'clear', 'warn');
      }
    );
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.pageSize = event.take
    this.getStockPurchasePlans();
  }

}


